import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularPinDown: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_pin-down"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="pin-down icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 16 17"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M11.6382 5.22361L8.44721 11.6056C8.26295 11.9741 7.73705 11.9741 7.55279 11.6056L4.3618 5.22361C4.19558 4.89116 4.43733 4.5 4.80902 4.5L11.191 4.5C11.5627 4.5 11.8044 4.89116 11.6382 5.22361Z" />
      </svg>
    </span>
  );
};

export { RegularPinDown };
